import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const FormulaRow = styled.div`
  margin-top: 8px;
`;

export const CalcIconCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.cultured};

  svg {
    width: 12px;
    height: 12px;
  }
`;
